import { useQuery } from '@tanstack/react-query';

import { attestation } from '@/api/endpoints/attestation';
import type { EntityId } from '@/api/types';

export interface AttestationFilters {
  from_iso?: string;
  to_iso?: string;
  witness_status?: 'ok' | 'pending' | 'down';
}

export const attestationKeys = {
  list: (root_id: EntityId, f: AttestationFilters) =>
    ['attestations', root_id, f] as const,
};

export function useAttestationList(root_id: EntityId | undefined, filters: AttestationFilters) {
  return useQuery({
    queryKey: attestationKeys.list(root_id ?? '', filters),
    queryFn: () => (root_id ? attestation.list(root_id, filters) : Promise.resolve([])),
    enabled: Boolean(root_id),
    staleTime: 15_000,
  });
}
